export const ACTIVE_BROWSER_SESSION = "ACTIVE_BROWSER_SESSION";

export function assertBrowserSessionAvailable() {
  const token = localStorage.getItem("token");
  if (!token) return;

  const error = new Error(
    "Një llogari tjetër është e hapur në këtë browser. " +
    "Rifreskoni faqen dhe dilni nga llogaria e hapur përpara se të kyçeni me një tjetër."
  );
  error.code = ACTIVE_BROWSER_SESSION;
  throw error;
}

// Web Locks serialize logins across tabs, including two initially empty login pages.
// The checks before the request and before saving remain in place without Web Locks.
export function withBrowserLoginLock(login) {
  if (typeof navigator !== "undefined" && navigator.locks?.request) {
    return navigator.locks.request("accountree-browser-login", login);
  }
  return login();
}
